import { combineReducers } from 'redux';
import * as actions from '../actions/ActionTypes';
import WordingService from '../services/WordingService';
import { path } from '../conf/route.conf';

const initialState = {
  qs: {},
  error: {
    title: WordingService.getWording('title', 'technicalError'),
    message: WordingService.getWording('caption', 'technicalError'),
    button: WordingService.getWording('button', 'end'),
  },
  whitelistPages: [path.ERROR],
  webViewMode: false,
  request: {
    name: '',
    isLoading: false,
  },
  isFirstConnection: false,
};

export const qs = (state = initialState.qs, action) => {
  switch (action.type) {
    case actions.REQUEST_ACCESS: {
      return {
        ...action.payload.qs,
      };
    }
    case actions.REMOVE_ACCESS_SUCCESS:
      return {
        ...action.payload.qs,
      };
    default:
      return state;
  }
};

export const error = (state = initialState.error, action) => {
  switch (action.type) {
    case actions.SET_ERROR_PAGE:
      switch (action.payload.error) {
        case 'technicalError':
          return {
            ...state,
            title: WordingService.getWording('title', 'technicalError'),
            message: WordingService.getWording('caption', 'technicalError'),
          };
        case 'resetIsPending':
          return {
            ...state,
            title: WordingService.getWording('title', 'passwordAvailableLater'),
            message: WordingService.getWording('caption', 'loginAfterDelay'),
          };
        case 'rtcForbiddenUnconfirmed':
          return {
            ...state,
            title: WordingService.getWording('title', 'accountAccess'),
            message: WordingService.getWording('caption', 'useTemporaryPassword'),
          };
        case 'rtcTechnicalError':
          return {
            ...state,
            title: WordingService.getWording('title', 'technicalError'),
            message: WordingService.getWording('caption', 'connectLaterWithTempPassword'),
          };
        case 'geolocalisation':
          return {
            ...state,
            title: WordingService.getWording('title', 'accessRestricted'),
            message: WordingService.getWording('caption', 'locationDenied'),
          };
        case 'otcSmsIsBlacklisted':
          return {
            ...state,
            title: WordingService.getWording('title', 'maxCodeAttempts'),
            message: WordingService.getWording('caption', 'maxSmsCodeAttempts'),
          };
        case 'otcMailIsBlacklisted':
          return {
            ...state,
            title: WordingService.getWording('title', 'maxCodeAttempts'),
            message: WordingService.getWording('caption', 'maxMailCodeAttempts'),
          };
        case 'otcAttemptsExceeded':
          return {
            ...state,
            title: WordingService.getWording('title', 'codeAttemptsExceeded'),
            message: WordingService.getWording('caption', 'codeAttemptsExceeded'),
          };
        case 'otcIsExpired':
          return {
            ...state,
            title: WordingService.getWording('title', 'codeExpired'),
            message: WordingService.getWording('caption', 'codeExpired'),
            button: WordingService.getWording('button', 'tryAgain'),
          };
        case 'blacklisted':
          return {
            ...state,
            title: WordingService.getWording('title', 'serviceDenied'),
            message: WordingService.getWording('caption', 'serviceDenied'),
          };
        case 'letterIsPending':
          return {
            ...state,
            title: WordingService.getWording('title', 'letterIsPending'),
            message: WordingService.getWording('caption', 'letterIsPending'),
          };
        case 'letterAttemptsExceeded':
          return {
            ...state,
            title: WordingService.getWording('title', 'postalCodeAttemptsExceeded'),
            message: WordingService.getWording('caption', 'postalCodeAttemptsExceeded'),
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

export const whitelistPages = (state = initialState.whitelistPages, action) => {
  switch (action.type) {
    case actions.ADD_WHITELIST_PAGE:
      if (!state.find(step => step === action.payload.step)) {
        return [...state, action.payload.step];
      }
      return state;
    case actions.DELETE_WHITELIST_PAGE: {
      return state.filter(step => step !== action.payload.step);
    }
    case actions.CLEAR_WHITELIST_PAGES:
      return initialState.whitelistPages;
    default:
      return state;
  }
};

const request = (state = initialState.request, action) => {
  if (action.type.includes(actions.apiRequest)) {
    return {
      ...state,
      name: action.type,
      isLoading: true,
    };
  }
  if (action.type.includes(actions.apiResponse)) {
    return {
      ...state,
      name: action.type,
      isLoading: false,
    };
  }
  return state;
};

export const webViewMode = (state = initialState.webViewMode, action) => {
  switch (action.type) {
    case actions.SET_WEBVIEW_MODE:
      return action.payload.isEnabled;
    default:
      return state;
  }
};

export const isFirstConnection = (state = initialState.isFirstConnection, action) => {
  switch (action.type) {
    case actions.SET_IS_FIRST_CONNECTION:
      return action.payload.isFirstConnection;
    default:
      return state;
  }
};

export default combineReducers({
  qs,
  error,
  whitelistPages,
  webViewMode,
  request,
  isFirstConnection,
});
